import CoaModel from '../coa/coa-model';
import JournalgroupModel from '../journalgroup/journalgroup-model';
import TransactiontypeModel from '../transactiontype/transactiontype-model';

export default class JournalgroupdetailModel {
    id: number;
    journalgroup: any;
    journalgroupCaption: string;
    transactiontype: any;
    transactiontypeCaption: string;
    sign: string;
    coa: any;
    coaCaption: string;

    constructor(datarow:any) {
        if (datarow.attributes) datarow = {...datarow.attributes, id: datarow.id}
        this.id = datarow.id;
        let journalgroup = datarow.journalgroup?.data? new JournalgroupModel(datarow.journalgroup?.data) : datarow.journalgroup;
        this.journalgroup = journalgroup?.id;
        this.journalgroupCaption = journalgroup?.name;
        let transactiontype = datarow.transactiontype?.data? new TransactiontypeModel(datarow.transactiontype?.data) : datarow.transactiontype;
        this.transactiontype = transactiontype?.id;
        this.transactiontypeCaption = transactiontype.name;
        this.sign = datarow.sign || 'debet';
        let coa = datarow.coa?.data? new CoaModel(datarow.coa?.data) : datarow.coa;
        this.coa = coa?.id;
        this.coaCaption = coa.name;
        
    } 

    public static endPoint: string = 'journal-group-details';     
    public static endPointFilterList = (journalgroupId?: number) => {
        return '?populate=*&sort=name&filters[journalgroup]=' + journalgroupId;
    }
    public static url: string = '/journalgroupdetail';
    public static caption: string = 'Journal Group Detail';

    public static defaultValue = () => {
        return {
        id: 0,
        journalgroup: null,
        journalgroupCaption: '',         
        transactiontype: null,
        transactiontypeCaption: '',         
        sign: 'debet',
        coa: null,
        coaCaption: '',
  
        }
    }
    
    public static columns = [
        { name: 'transactiontypeCaption', caption: 'Transaction Type' },
        { name: 'sign', caption: 'Debet/Credit' },
        { name: 'coaCaption', caption: 'COA' },
    ]

    public static columnPicklist = [
        { name: 'transactiontypeCaption', caption: 'Transaction Type' },
        { name: 'sign', caption: 'Debet/Credit' },
        { name: 'coaCaption', caption: 'COA' },
    ]
    
    public static optionSign = [
        { name: 'debet', caption: 'Debet' },
        { name: 'credit', caption: 'Credit' },
    ]

}